import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { PaginatedCollection } from "./PaginatedCollection";
// eslint-disable-next-line import/no-cycle
import { TileCollection } from "./TileCollection";
// eslint-disable-next-line import/no-cycle
import { TileSlider } from "./TileSlider";

// TODO:: Task 99842: CardCollection, Tile Slider and Paginated collection Update

const CardCollectionConnector = ({ data }) => {
	let cardsArray = data.cards;
	if (!cardsArray) {
		cardsArray = [];
	}
	if (cardsArray.length > 0 && data.limitNumberOfCards && data.limitNumberOfCards > 0) {
		cardsArray = cardsArray.slice(0, data.limitNumberOfCards);
	}

	for (let i = 0; i < cardsArray.length; i++) {
		const checklistItems = cardsArray?.[i]?.checkListItems;
		const parsedChecklist = [];

		if (checklistItems) {
			for (let j = 0; j < checklistItems.length; j++) {
				if (checklistItems?.[j]?.item) {
					parsedChecklist.push(checklistItems?.[j]);
				} else {
					const item = {
						id: j,
						item: checklistItems[j],
					};

					parsedChecklist.push(item);
				}
			}

			cardsArray[i].checkListItems = parsedChecklist;
		}
	}

	switch (data.variant) {
		case "paging":
			return (
				<PaginatedCollection
					paginatedEntries={cardsArray}
					entriesPerPage={data.cardsPerPage}
					variant={data.cardVariant}
					largeTiles={data.largeTiles}
				/>
			);
		case "slider":
			return (
				<TileSlider
					title={data.displayTitle}
					tiles={cardsArray}
					variant={data.cardVariant}
					id={data?.id}
					slidesPerPage={data?.slidesPerPage}
				/>
			);
		default:
			return (
				<TileCollection
					title={data.displayTitle}
					tiles={cardsArray}
					variant={data.cardVariant}
					largeTiles={data.largeTiles}
					mobileSlider={data.mobileSlider}
					paginatedEntries={cardsArray}
					entriesPerPage={data.cardsPerPage}
					slidesPerPage={data.slidesPerPage}
					hideLinks={data.hideLinks}
					theme={data.theme}
					id={data?.id}
				/>
			);
	}
};

CardCollectionConnector.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string,
		displayTitle: PropTypes.string,
		cardVariant: PropTypes.string,
		cards: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.string,
				title: PropTypes.string,
				link: PropTypes.shape({
					url: PropTypes.string,
					target: PropTypes.string,
				}),
				image: PropTypes.shape({
					file: PropTypes.shape({
						url: PropTypes.string,
					}),
				}),
				cloudinaryImage: PropTypes.arrayOf(PropTypes.object),
				checkListItems: PropTypes.arrayOf(PropTypes.string),
				sourceSet: PropTypes.arrayOf(PropTypes.object),
			})
		),
		paginateEntries: PropTypes.bool,
		cardsPerPage: PropTypes.number,
		slidesPerPage: PropTypes.number,
		limitNumberOfCards: PropTypes.number,
		largeTiles: PropTypes.bool,
		mobileSlider: PropTypes.bool,
		variant: PropTypes.string,
		hideLinks: PropTypes.bool,
		theme: PropTypes.string,
	}),
	id: PropTypes.string,
};
CardCollectionConnector.defaultProps = {
	data: null,
	id: null,
};

export default CardCollectionConnector;
export { CardCollectionConnector };
